import {CHANGE_LANG} from "../constants/actionTypes";

export const changeLangAction = (payload) => ({
    type: CHANGE_LANG,
    payload
})